var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveBreakoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 5.46875C3.125 4.71454 3.42461 3.99122 3.95792 3.45792C4.49122 2.92461 5.21454 2.625 5.96875 2.625H16.0312C16.7855 2.625 17.5088 2.92461 18.0421 3.45792C18.5754 3.99122 18.875 4.71454 18.875 5.46875V15.5312C18.875 16.2855 18.5754 17.0088 18.0421 17.5421C17.5088 18.0754 16.7855 18.375 16.0312 18.375H11.6248C12.3491 17.6055 12.7517 16.5881 12.75 15.5312V12.9062C12.75 11.8039 12.3121 10.7468 11.5327 9.96734C10.7532 9.18789 9.69606 8.75 8.59375 8.75H5.96875C4.86888 8.75 3.86875 9.177 3.125 9.87525V5.46875ZM3.125 12.9062V15.5312C3.125 16.2855 3.42461 17.0088 3.95792 17.5421C4.49122 18.0754 5.21454 18.375 5.96875 18.375H8.59375C9.34796 18.375 10.0713 18.0754 10.6046 17.5421C11.1379 17.0088 11.4375 16.2855 11.4375 15.5312V12.9062C11.4375 12.152 11.1379 11.4287 10.6046 10.8954C10.0713 10.3621 9.34796 10.0625 8.59375 10.0625H5.96875C5.21454 10.0625 4.49122 10.3621 3.95792 10.8954C3.42461 11.4287 3.125 12.152 3.125 12.9062Z",
    fill: "#178EFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBreakoutIcon);
export default __webpack_public_path__ + "static/media/active-breakout-icon.cb6ae50acf06b63692208d648240b7d2.svg";
export { ForwardRef as ReactComponent };